const FileImage = ({
    height = 100,
    width = 100,
}: {
    height?: number
    width?: number
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 287.82 384"
            width={width}
            height={height}
        >
            <path
                fill="#00cc69"
                d="M652.52 792.45h192s50.06.1 49-59.26 0-210.58 0-210.58H785.16l-1-114.16H652.52s-45.94 1.52-46.52 53 0 284.71 0 284.71 4.19 44.97 46.52 46.29z"
                transform="translate(-605.74 -408.45)"
            ></path>
            <path
                fill="#49db95"
                d="M178.39 0L287.82 114.16 179.42 114.16 178.39 0z"
            ></path>
            <path
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="10"
                d="M167.31 283.05l-16.14-15.67c-7.79-7.56-11.69-11.34-16.16-12.72a19.68 19.68 0 00-12 .13c-4.44 1.47-8.25 5.34-15.87 13.06l-38.67 37.4m98.89-22.2l3.3-3.2c7.8-7.57 11.7-11.36 16.17-12.74a19.67 19.67 0 0112.07.14c4.44 1.48 8.25 5.35 15.87 13.09l8.09 8m-55.5-5.27l38.81 38.08m0 0a135 135 0 01-14.27.41H99c-10.83 0-16.25 0-20.39-2.07a19.08 19.08 0 01-8.46-8.28 17.19 17.19 0 01-1.68-5.94m137.7 15.88a18.44 18.44 0 006.13-1.66 19.06 19.06 0 008.45-8.28c2.11-4 2.11-9.35 2.11-20v-2.9M68.42 305.25a124.38 124.38 0 01-.43-14v-90.97c0-10.61 0-15.91 2.11-20a19.18 19.18 0 018.46-8.28c4.14-2.06 9.56-2.06 20.39-2.06h92.9c10.84 0 16.26 0 20.4 2.06a19.16 19.16 0 018.45 8.28c2.11 4.06 2.11 9.36 2.11 20v88m-29-71a19.35 19.35 0 11-19.35-18.94 19.15 19.15 0 0119.32 18.99z"
            ></path>
        </svg>
    )
}

export default FileImage
